import { SidePanel as G } from "./index7.mjs";
import e, { lazy as I, useState as N, useMemo as W, useEffect as d, Suspense as g } from "react";
import F from "./index8.mjs";
import { track as U } from "./index9.mjs";
import { TRACK_EVENT_TYPE as H, TRACK_EVENT as Y } from "./index10.mjs";
import { Loader as s } from "./index11.mjs";
import { useSetupBookingEngine as v } from "./index12.mjs";
import { getConfigPropertyAtomCreator as x, ConfigProperty as M, ViewLayout as c } from "./index13.mjs";
import { useAtomValue as h } from "jotai/index";
import { getSubscriptionPlanRoot as j } from "./index14.mjs";
const q = I(() => import("./index5.mjs")), z = I(() => import("./index6.mjs")), me = ({
  locale: L,
  maxAdults: C,
  maxChildren: O,
  isFullAddressRequired: k,
  vgsEnvironment: w,
  googleMapsApiKey: A,
  hotelId: n,
  hotelName: R,
  hotelEmail: T,
  propertyType: r,
  propertySize: i,
  subscriptionPlan: m,
  onClose: a,
  regions: B,
  hasPromocodeEnabled: l = !1,
  clientBookingToken: V,
  vgsVaultId: K,
  roomId: P
}) => {
  const [D, b] = N(
    P
  ), [u, t] = N(
    !1
  ), f = h(
    W(() => x(M.VIEW_LAYOUT), [])
  ) === c.FULL_SCREEN, { isSearchCriteriaSet: _, bookingData: y } = v(
    {
      locale: L,
      maxAdults: C,
      maxChildren: O,
      isFullAddressRequired: k,
      vgsEnvironment: w,
      googleMapsApiKey: A,
      hotelId: n,
      hotelName: R,
      hotelEmail: T,
      propertyType: r,
      propertySize: i,
      subscriptionPlan: m,
      regions: B,
      hasPromocodeEnabled: l,
      clientBookingToken: V,
      vgsVaultId: K
    },
    f ? c.FULL_SCREEN : c.SIDE_PANEL
  );
  return d(() => {
    _ && t(!0);
  }, [_]), d(() => {
    const o = (E) => {
      var p;
      const S = (p = E == null ? void 0 : E.detail) == null ? void 0 : p.roomId;
      U(Y.CLICK, H.BOOKING_ENGINE_STARTED, {
        hotel_id: n,
        property_type: r,
        property_size: i,
        subscription_plan: j(m),
        promo_code_shown: l
      }), t(!0), S && b(S);
    };
    return window.eventbus.on(EVENTS.SHOW_BOOKING_SIDE_PANEL, o), () => {
      window.eventbus.off(EVENTS.SHOW_BOOKING_SIDE_PANEL, o);
    };
  }, [
    r,
    i,
    l,
    n,
    m
  ]), f ? null : /* @__PURE__ */ e.createElement("div", { "data-testid": "booking-engine", className: F.container }, a ? null : /* @__PURE__ */ e.createElement(g, { fallback: /* @__PURE__ */ e.createElement(s, null) }, /* @__PURE__ */ e.createElement(
    z,
    {
      onClick: () => {
        t(!0);
      }
    }
  )), /* @__PURE__ */ e.createElement(
    G,
    {
      isShow: u,
      onClose: () => {
        a && a(y), t(!1);
      }
    },
    (o) => u ? /* @__PURE__ */ e.createElement(g, { fallback: /* @__PURE__ */ e.createElement(s, null) }, /* @__PURE__ */ e.createElement(q, { ...o, roomId: D })) : /* @__PURE__ */ e.createElement(s, null)
  ));
};
export {
  me as BookingEngine
};
